import React, { useState, useEffect, useRef } from 'react';
import Login from './components/Login'; //ログイン画面
import Register from './components/Register'; //ユーザー登録画面
import CardSearch from './components/CardSearch';
import DeckBuilder from './components/DeckBuilder';
import CardDetails from './components/CardDetails';
import RepresentativeCardModal from './components/RepresentativeCardModal'; // ← 新規作成するモーダルコンポーネント
import { Routes, Route, Link } from 'react-router-dom';
import './App.css';
import { cards } from './data/cards';
import PublicDecks from './components/PublicDecks';
import UserSettingsModal from './components/UserSettingsModal';
import UserEditModal from './components/UserEditModal';


function App() {
 // JWT認証関連
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem('token')
  );
  const [isRegisterMode, setIsRegisterMode] = useState(false);
  const [userInfo, setUserInfo] = useState(null); // 👈 ログイン中ユーザー情報を保持

  const [deck, setDeck] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);
  const [activeTab, setActiveTab] = useState('search'); 
  const [underlinePosition, setUnderlinePosition] = useState(0); 
  // 各マスタデータ
  const [cardTypeOptions, setCardTypeOptions] = useState([]);
  const [elementOptions, setElementOptions] = useState([]);
  const [subElementOptions, setSubElementOptions] = useState([]);
  const [powerOptions, setPowerOptions] = useState([]);
  const [corpsOptions, setCorpsOptions] = useState([]);
  const [levelOptions, setLevelOptions] = useState([]);
  const [sexOptions, setSexOptions] = useState([]);
  const [plusPowerTargetOptions, setPlusPowerTargetOptions] = useState([]);
  const [plusPowerOptions, setPlusPowerOptions] = useState([]);
  const [chapterOptions, setChapterOptions] = useState([]);
  const [continentOptions, setContinentOptions] = useState([]);

  // モーダル状態管理
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mainCardId, setMainCardId] = useState(null);
  const [onConfirmMainCard, setOnConfirmMainCard] = useState(null); // モーダル確定時に呼ばれる関数

  const [isUserSettingsOpen, setIsUserSettingsOpen] = useState(false);
  const [isUserEditOpen, setIsUserEditOpen] = useState(false);

  // PublicDecks / DeckBuilder と共有するトリガー
  const [reloadDeckListTrigger, setReloadDeckListTrigger] = useState(0);

  // 詳細の表示/非表示
  const [isRightPanelOpen, setIsRightPanelOpen] = useState(true);

  const rightPanelRef = useRef(null);

  useEffect(() => {
    if (rightPanelRef.current) {
      rightPanelRef.current.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }, [selectedCard]);

  // APIデータ取得用の汎用関数
/*   const fetchData = async (url, setter, errorMessage) => {
    try {
      const response = await fetch(url);
      const data = await response.json();
      setter(data);
    } catch (error) {
      console.error(errorMessage, error);
    }
  }; */

  async function authFetch(url, options = {}) {
    const token = localStorage.getItem("token");

    // ヘッダー設定
    const headers = {
      ...(options.headers || {}),
      Authorization: token ? `Bearer ${token}` : undefined,
      "Content-Type": "application/json",
    };

    let res = await fetch(url, {
      ...options,
      headers,
      credentials: "include" // ← refreshToken cookie を使うために必要
    });

    // トークン期限切れなら refresh
    if (res.status === 401 || res.status === 403) {
      console.log("🔄 Token expired, refreshing...");

      const refreshRes = await fetch("/api/refresh", {
        method: "POST",
        credentials: "include",
      });

      if (!refreshRes.ok) {
        console.warn("❌ refresh 失敗 → ログアウトへ");
        localStorage.removeItem("token");
        window.location.reload();
        return;
      }

      const refreshData = await refreshRes.json();
      localStorage.setItem("token", refreshData.token);

      // 🔁 リトライ
      const retryHeaders = {
        ...(options.headers || {}),
        Authorization: `Bearer ${refreshData.token}`,
        "Content-Type": "application/json",
      };

      res = await fetch(url, {
        ...options,
        headers: retryHeaders,
        credentials: "include",
      });
    }

    return res;
  }

  // ✅ APIデータ取得用の共通関数（JWT対応）
/*   const fetchData = async (url, setter, errorMessage) => {
    try {
      await refreshTokenIfNeeded();

      const token = localStorage.getItem('token'); // JWTを取得
      const response = await fetch(url, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });

      // トークンが無効な場合（HTTP 401 or 403）
      if (response.status === 401 || response.status === 403) {
        console.warn('トークンが無効または期限切れ');
        localStorage.removeItem('token');
        setIsAuthenticated(false);
        return;
      }

      const data = await response.json();
      setter(data);
    } catch (error) {
      console.error(errorMessage, error);
    }
  }; */

/*   // JWT の残り時間をチェック
  const getTokenRemainingTime = (token) => {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.exp * 1000 - Date.now();
    } catch (e) {
      return 0;
    }
  }; */

/*   // トークンのリフレッシュ
  const refreshTokenIfNeeded = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    const remaining = getTokenRemainingTime(token);
    if (remaining > 5 * 60 * 1000) return; // 5分以上残っているなら更新不要

    console.log("🔄 Token 残り5分 → 更新");

    const res = await fetch("http://localhost:3001/api/refresh", {
      method: "POST",
      credentials: "include"   // ← cookie 送信
    });

    const data = await res.json();

    if (data.token) {
      localStorage.setItem("token", data.token);
      console.log("🔑 Token 更新完了");
    }
  }; */



  // ログアウト処理
  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
    setUserInfo(null);
  };

  // ログイン済みのとき各マスタデータを取得
  useEffect(() => {
    if (!isAuthenticated) return; // ← 条件チェックは中に移動！

    const token = localStorage.getItem('token');
    fetch('/api/profile', {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.error) {
          setUserInfo(data.user);
        } else {
          // 無効トークン時は強制ログアウト
          console.warn('トークン無効。再ログインが必要です');
          handleLogout();
        }
      })
      .catch((err) => {
        console.error('プロフィール取得エラー:', err);
        handleLogout();
      });
    
/*     fetchData('http://localhost:3001/api/card_type', setCardTypeOptions, 'カード分類取得エラー:');
    fetchData('http://localhost:3001/api/main_element', setElementOptions, '属性データ取得エラー:');
    fetchData('http://localhost:3001/api/sub_element', setSubElementOptions, 'サブ属性データ取得エラー:');
    fetchData('http://localhost:3001/api/power', setPowerOptions, 'パワーデータ取得エラー:');
    fetchData('http://localhost:3001/api/corps', setCorpsOptions, '軍団データ取得エラー:');
    fetchData('http://localhost:3001/api/level', setLevelOptions, 'レベルデータ取得エラー:');
    fetchData('http://localhost:3001/api/sex', setSexOptions, '性別データ取得エラー:');
    fetchData('http://localhost:3001/api/plus_power_target', setPlusPowerTargetOptions, '＋修正対象データ取得エラー:');
    fetchData('http://localhost:3001/api/plus_power', setPlusPowerOptions, '＋修正データ取得エラー:');
    fetchData('http://localhost:3001/api/chapter', setChapterOptions, '章データ取得エラー:');
    fetchData('http://localhost:3001/api/continent', setContinentOptions, '大陸データ取得エラー:'); */
    
    authFetch('/api/card_type')
      .then((res) => res.json())
      .then((data) => setCardTypeOptions(data))
      .catch(err => console.error("カード分類取得エラー:", err));
    authFetch('/api/main_element')
      .then((res) => res.json())
      .then((data) => setElementOptions(data))
      .catch(err => console.error("属性データ取得エラー:", err));
    authFetch('/api/sub_element')
      .then((res) => res.json())
      .then((data) => setSubElementOptions(data))
      .catch(err => console.error("サブ属性データ取得エラー:", err));
    authFetch('/api/power')
      .then((res) => res.json())
      .then((data) => setPowerOptions(data))
      .catch(err => console.error("パワーデータ取得エラー:", err));
    authFetch('/api/corps')
      .then((res) => res.json())
      .then((data) => setCorpsOptions(data))
      .catch(err => console.error("軍団データ取得エラー:", err));
    authFetch('/api/level')
      .then((res) => res.json())
      .then((data) => setLevelOptions(data))
      .catch(err => console.error("レベルデータ取得エラー:", err));
    authFetch('/api/sex')
      .then((res) => res.json())
      .then((data) => setSexOptions(data))
      .catch(err => console.error("性別データ取得エラー:", err));
    authFetch('/api/plus_power_target')
      .then((res) => res.json())
      .then((data) => setPlusPowerTargetOptions(data))
      .catch(err => console.error("＋修正対象データ取得エラー:", err));      
    authFetch('/api/plus_power')
      .then((res) => res.json())
      .then((data) => setPlusPowerOptions(data))
      .catch(err => console.error("＋修正データ取得エラー:", err));      
    authFetch('/api/chapter')
      .then((res) => res.json())
      .then((data) => setChapterOptions(data))
      .catch(err => console.error("章データ取得エラー:", err));
    authFetch('/api/continent')
      .then((res) => res.json())
      .then((data) => setContinentOptions(data))
      .catch(err => console.error("大陸データ取得エラー:", err));            
  }, [isAuthenticated]);

  // 🔐 未ログイン時
  if (!isAuthenticated) {
    return isRegisterMode ? (
      <Register switchToLogin={() => setIsRegisterMode(false)} />
    ) : (
      <Login
        onLoginSuccess={() => setIsAuthenticated(true)}
        switchToRegister={() => setIsRegisterMode(true)}
      />
    );
  }

  // デッキ構築関連
  const addCardToDeck = (card) => {
    setDeck((prevDeck) => {
      if (!prevDeck.some(deckCard => deckCard.card_id === card.card_id)) {
        return [...prevDeck, card]; 
      }
      return prevDeck;
    });
  };

  const removeCardFromDeck = (cardId) =>
    setDeck(deck.filter((c) => c.card_id !== cardId));

  const showCardDetails = (card) => setSelectedCard(card);

  const handleTabClick = (tabName, index) => {
    setActiveTab(tabName);
    setUnderlinePosition(index * 100); // タブ幅を考慮
  };

  const handleLoadDeck = (loadedCards) => {
    setDeck(loadedCards);
  };

  const openModal = (onConfirm) => {
    setOnConfirmMainCard(() => onConfirm); // 関数を一時保存
    setIsModalOpen(true);
  };

  const confirmMainCard = () => {
    if (mainCardId && onConfirmMainCard) {
      onConfirmMainCard(mainCardId); // DeckSaveLoad 側から渡された処理を呼ぶ
    }
    setIsModalOpen(false);
    setMainCardId(null);
    setOnConfirmMainCard(null);
  };

  const showCardDetailsById = async (cardId) => {
    if (!cardId) return;

    try {
      const res = await authFetch(`/api/cards/${cardId}`);

      if (!res.ok) {
        console.error("HTTP error:", res.status);
        return;
      }

      const data = await res.json();
      setSelectedCard({ ...data }); // 再レンダリング保証
    } catch (err) {
      console.error("カード取得失敗:", err);
    }
  };



  return (
      <div className="App">
        <header className="app-header">
          <h1>MOZ DB (DataBase & DeckBuild)</h1>
          {/* タブ切り替えに変更したためリンク削除 */}
          {/* <Link to="/public-decks" className="public-link">公開中デッキページへ</Link> */}
          {userInfo && <span> ログイン中： {userInfo.user_name} </span>}
          <button className="user-settings-btn" onClick={() => setIsUserSettingsOpen(true)}>
            ⚙ ユーザー設定
          </button>
          <button className={`detail-toggle-btn ${!isRightPanelOpen ? 'closed' : ''}`}
            onClick={() => setIsRightPanelOpen(prev => !prev)}
          >
            {isRightPanelOpen ? '詳細を閉じる' : '詳細を開く'}
          </button>
          <button className="logout-btn" onClick={handleLogout}>ログアウト</button>
        </header>

        <Routes>
          <Route path="/" element={
            <>
            <div className={`overlay-container ${isModalOpen ? 'disabled' : ''}`}>
              <div className={`main-container ${!isRightPanelOpen ? 'right-closed' : ''}`}>
                <div className="left-panel">
                  <div className="tab-buttons">
                    <button className={activeTab === 'search' ? 'active' : ''} onClick={() => handleTabClick('search', 0)}>
                      カード検索
                    </button>
                    <button className={activeTab === 'deck' ? 'active' : ''} onClick={() => handleTabClick('deck', 1)}>
                      デッキ構築
                    </button>
                    <button className={activeTab === 'public' ? 'active' : ''} onClick={() => handleTabClick('public', 2)}>
                      公開デッキ一覧
                    </button>
                    {/* 🔹 アンダーラインをここに配置 */}
                    <div className="tab-underline" style={{ transform: `translateX(${underlinePosition}%)` }}></div>
                  </div>

                  <div className="tab-content">
                    <div style={{ display: activeTab === 'search' ? 'block' : 'none' }}>
                      <CardSearch
                        cards={cards}
                        addCardToDeck={addCardToDeck}
                        deck={deck}
                        showCardDetails={showCardDetails}
                        cardTypeOptions={cardTypeOptions}
                        elementOptions={elementOptions}
                        subElementOptions={subElementOptions}
                        powerOptions={powerOptions}
                        corpsOptions={corpsOptions}
                        levelOptions={levelOptions}
                        sexOptions={sexOptions}
                        plusPowerTargetOptions={plusPowerTargetOptions}
                        plusPowerOptions={plusPowerOptions}
                        chapterOptions={chapterOptions}
                      />
                    </div>
                    <div style={{ display: activeTab === 'deck' ? 'block' : 'none' }}>
                      <DeckBuilder
                        deck={deck}
                        removeCardFromDeck={removeCardFromDeck}
                        showCardDetails={showCardDetails}
                        cardTypeOptions={cardTypeOptions}
                        elementOptions={elementOptions}
                        subElementOptions={subElementOptions}
                        powerOptions={powerOptions}
                        corpsOptions={corpsOptions}
                        levelOptions={levelOptions}
                        sexOptions={sexOptions}
                        plusPowerTargetOptions={plusPowerTargetOptions}
                        plusPowerOptions={plusPowerOptions}
                        chapterOptions={chapterOptions}
                        continentOptions={continentOptions}
                        onLoadDeck={handleLoadDeck}
                        openModal={openModal}
                        userInfo={userInfo}
                        reloadTrigger={reloadDeckListTrigger}
                        setReloadTrigger={setReloadDeckListTrigger}
                      />
                    </div>
                    <div style={{ display: activeTab === 'public' ? 'block' : 'none' }}>
                      <PublicDecks
                        cardTypeOptions={cardTypeOptions}
                        levelOptions={levelOptions}
                        sexOptions={sexOptions}
                        elementOptions={elementOptions}
                        subElementOptions={subElementOptions}
                        powerOptions={powerOptions}
                        reloadTrigger={reloadDeckListTrigger}
                        setReloadTrigger={setReloadDeckListTrigger}
                      />
                    </div>
                  </div>
                </div>
                <div className={`right-panel ${!isRightPanelOpen ? 'closed' : ''}`}>
                  <div className="right-panel-content" ref={rightPanelRef}>
                    <CardDetails
                      card={selectedCard}
                      onChangeCard={(card) => showCardDetailsById(card.cynergy_card_id)}
                     />
                  </div>
                </div>
              </div>
            </div>
            {isModalOpen && (
              <RepresentativeCardModal
                deck={deck}
                mainCardId={mainCardId}
                setMainCardId={setMainCardId}
                onConfirm={confirmMainCard}
                onCancel={() => {
                  setIsModalOpen(false);
                  setMainCardId(null);
                }}
              />
            )}
            {isUserSettingsOpen && (
              <UserSettingsModal
                userInfo={userInfo}
                onClose={() => setIsUserSettingsOpen(false)}
                onEdit={() => {
                  setIsUserSettingsOpen(false);
                  setIsUserEditOpen(true);
                }}
              />
            )}

            {isUserEditOpen && (
              <UserEditModal
                userInfo={userInfo}
                onClose={() => setIsUserEditOpen(false)}
                onSave={async ({ userName, mailAddress, currentPw, newPw }) => {
                  try {
                    const token = localStorage.getItem("token");
                    const res = await fetch("/api/user/update", {
                      method: "PUT",
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                      },
                      body: JSON.stringify({
                        user_name: userName,
                        mail_address: mailAddress,
                        current_password: currentPw,
                        new_password: newPw,
                      }),
                    });

                    const data = await res.json();
                    if (!res.ok) {
                      alert(data.error || "更新失敗");
                      return;
                    }

                    // 新 accessToken を保存
                    localStorage.setItem("token", data.accessToken);

                    // userInfo 再更新
                    setUserInfo(prev => ({
                      ...prev,
                      user_name: userName,
                      mail_address: mailAddress
                    }));

                    alert("更新完了しました");
                    setIsUserEditOpen(false);
                  } catch (err) {
                    console.error("更新エラー:", err);
                    alert("エラーが発生しました");
                  }
                }}
              />
            )}
            </>
          }
        />
          {/* 公開デッキ一覧ページ */}
          <Route path="/public-decks" element={<PublicDecks
                                                  cardTypeOptions={cardTypeOptions}
                                                  levelOptions={levelOptions}
                                                  sexOptions={sexOptions}
                                                  elementOptions={elementOptions}
                                                  subElementOptions={subElementOptions}
                                                  powerOptions={powerOptions}
           />} />
        </Routes>
      </div>
  );
}

export default App;
